export const benefitsCode =
`
  <BenefitsBanner
    colorScheme="db01"
    highlighted="Fusce vehicula dolor arcu, sit sec."
    items={items}
    subtitle="Nam porttitor blandit accumsan. Ut vel dictum sem, a pretium dui. In malesuada."
    title="Curabitur lobortis id is bibendum."
  />
`;

export const cardsBannerCode = 
`
  <CardBanner
    title="Lorem ipsum"
    tabKey="key"
    className="main-content"
    {...versionProps}
  />
`;

export const landingSkinnyBannerCode = 
`
  <SkinnyBanner {...props} />
`;

export const selfcareSkinnyBannerCode = 
`
  <SkinnySelfcareA
    className="main-content"
    icon="apps"
    highlighted="Lorem ipsum dolor eiusmod sitsd."
    title="Consectetur adipiscing elits."
    description="Excepteur sint occaecat cupidata non proident sunt in culpa officia."
    button="action"
  />
`;

export const supportBannerCode = 
`
  <SupportBanner
    className="main-content"
    title="We’re here to help your"
    highlighted="business succeed."
  >
    <SupportGroup
      title="Get in touch."
      description="Reach us if you need further information or have any questions."
      link="contact us"
      onClick={(e) => e.preventDefault()}
    />
    <SupportGroup
      title="Need help?"
      description="We put together a list of answers for frequently asked questions."
      link="Faqs"
      onClick={(e) => e.preventDefault()}
    />
    <SupportGroup
      title="Our Newsletter"
      description="Subscribe our newsletter to be the first to hear what’s happening."
      placeholder="Input text"
      onClick={() => console.log('input was clicked')}
    />
  </SupportBanner>
`;

export const hubBannerCode = 
`
  <HubBanner
    highlighted="Lorem ipsum at"
    title="dolor sit amet"
    description="Ut enim ad minim veniam, quis nostrud exercitation."
    items={hubBannerItems}
  />
`;

export const heroBannerTypeACode = 
`
  <HeroWrapper>
    <HeroA
      label="Airtel Business Internet"
      title={heroTitle}
      description={description}
      link="only text"
      onClick={() => console.log('link clicked')}
    />
    <HeroA
      label="Airtel Business Internet"
      title={heroTitle}
      description={description}
      link="only text"
      onClick={() => console.log('link clicked')}
      right
    />
  </HeroWrapper>
`;

export const heroBannerTypeBCode = 
`
  <HeroWrapper>
    <HeroA4
      colorScheme="lb01"
      label="Lorem ipsum dolor sit amet"
      title="Lorem ipsum dolor sit amet, dolor sit."
    />
    <HeroB
      colorScheme="lb01"
      description={description}
      button={{ type: 'primary', innerText: 'button' }}
      onClick={() => console.log('button clicked')}
    />
  </HeroWrapper>
`;

export const heroBannerTypeCCode = 
`
  <HeroWrapper youtubeVideoId="kAznA6cFErw">
    <HeroA
      label="Airtel Business Internet"
      title={heroTitle}
      description={description}
      link="only text"
      onClick={() => console.log('link clicked')}
    /> 
    <HeroC />
  </HeroWrapper>
`;

export const heroBannerTypeDCode = 
`
  <HeroWrapper>
    <HeroA
      label="Airtel Business Internet"
      title="Lorem ipsum dolor sit amet"
      description={description}
      link="only text"
      onClick={() => console.log('link clicked')}
    /> 
    <HeroDWrapper>
      <HeroD
        title="Lorem ipsum dolor sit amet"
        description="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi a imperdiet nulla."
        onClick={() => console.log('click')}
        link="only text"
      />
      <HeroD
        title="Lorem ipsum dolor sit amet"
        description="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi a imperdiet nulla."
        onClick={() => console.log('click')}
        link="only text"
        colorScheme="lb02"
      />
    </HeroDWrapper>
  </HeroWrapper>
`;

export const heroBannerTypeECode = 
`
  <HeroWrapper colorScheme="pb01" thumbnail="path/to/image">
    <HeroA4
      label="Lorem ipsum dolor sit amet"
      title="Lorem ipsum dolor sit amet, dolor sit."
    />
    <HeroB
      description={'Lorem ipsum dolor sit amet, consectetur adipiscing elit.'}
      button={{ type: 'primary', innerText: 'button' }}
      onClick={() => console.log('button clicked')}
      v2
    />
    <HeroE
      description="Description up to three lines of the text."
      sections={
        [
          {
            icon: { icon: 'hot-deals', type: '20' },
            description: 'Description up to three lines of the text.'
          },
          {
            icon: { icon: 'hot-deals', type: '20' },
            description: 'Description up to three lines of the text.'
          }
        ]
      } />
  </HeroWrapper>
`;

export const testimonialsBannerCode = 
`
  <TestimonialsBanner testimonials={testimonials} autoplay />
`;

export const carouselBannerCode = 
`
  <CarouselBanner left slides={carouselSlides} autoplay className="main-content" />
`;

export const articlesBannerCode = 
`
  <ArticlesBanner
    label="Knowledge Hub"
    pageLink="go to page"
    pageCallback={() => console.log('go to page')}
    highlighted="We are committed to the highest standards of corporate governance."
    description="This reflects in our ethical business decisions and transparent conduct."
    articles={articlesArray}
  />
`;

export const advantagesBannerCode = 
`
  <AdvantagesBanner
    offers={offers}
    statistics={statistics}
    backgroundImage="path/to/your/bgImage"
  />
`;

export const newsBannerCode = 
`
  <NewsBanner
    label="Latest News"
    pageLink="View All"
    pageCallback={() => console.log('go to page')}
    news={newsArray}
  />
`;

export const mediaBannerCode = 
`
  <MediaBanner
    slides={mediaBannerData}
    {...props}
  />
`;


// WEBPACK FOOTER //
// ./src/containers/components/Banner/constants/bannersCode.js